import script from "./MainComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainComponent.vue?vue&type=script&lang=ts&setup=true"

import "./MainComponent.vue?vue&type=style&index=0&id=da0f7e80&lang=scss"

const __exports__ = script;

export default __exports__